import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard, Invoice, Layout, ListOrders, Inventory, Customers, Users } from "./screens";
import InvoiceDetails from "Screens/Invoice/InvoiceDetails";
import InvoiceDraftList from "Screens/Invoice/InvoiceDraftList";

export const Authenticated = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}

        <Route path="/" element={<Invoice />} />

        <Route path="invoice/">
          <Route path="createInvoice" element={<Invoice />} />
          <Route path="invoiceDetails" element={<InvoiceDetails />} />
          <Route path="draftList" element={<InvoiceDraftList />} />
        </Route>
        <Route path="customers/">
          <Route path="createCustomer" element={<Customers />} />
        </Route>
        <Route path="inventory/" element={<Inventory />} />
        <Route path="orders/">
          <Route path="listOrder" element={<ListOrders />} />
        </Route>
        <Route path="users/" element={<Users />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};
